import { FulfillmentCenter } from 'src/features/types'

export interface StockAddressingInBatchState {
  uploadFilePage: {
    stockAddressing?: StockAddressing
    stockAddressingFile?: File
    invalidStructure?: InvalidStructureDetails
    salesChannelsByFC: SalesChannel[]
    selectedSalesChannels: SelectedSalesChannel[]
  }
}

export interface StockAddressing {
  id: number
  createdAt: Date
  userId: number
  status: StockAddressingStatus
}

export enum StockAddressingStatus {
  INVALID = 'INVALID',
}

export enum ErrorTypes {
  FAILED_UPLOAD = 'FAILED_UPLOAD',
  INVALID_STRUCTURE = 'INVALID_STRUCTURE',
  ERROR = 'ERROR'
}

export interface InvalidStructureDetails {
  missingColumns: string[]
}

export interface FailedUploadDetails {
  message?: string
}

export interface ErrorDetails {
  message?: string
}

export interface GetSalesChannels {
  fulfillmentCenterId?: number
}

export interface SalesChannel {
  id: number
  name: string
}

export interface SelectedSalesChannel {
  fulfillmentCenter: FulfillmentCenter
  salesChannel: SalesChannel
}

export interface SubmitFileValues {
  file: File
  salesChannels: SalesChannel[]
}
